<script lang="ts">
    import { _ } from "svelte-i18n"
    import { navigate } from "../../../../../vendor/svelte-routing"

    import { checkoutData, contentOverlay, login, location } from "../../../store"
    import { getProductPrice } from "../../../utils"

    import ProductImage from "../../product/ProductImage.svelte"
    import ProductThumbnails from "../../product/ProductThumbnails.svelte"
    import ProductOptions from "../../product/ProductOptions.svelte"
    import ProductInquiry from "../../product/ProductInquiry.svelte"
    import { formatPriceCurrency, langField } from "../../../i18n"

    export let product: Product
    let activeImage: ImageEntry
    export let activeColor: RALColor = undefined
    export let activeOptions: string[]
    let imageColorMismatch = false

    let product_path: string

    $: {
        let hash = ""

        try {
            if (typeof btoa !== "undefined") {
                hash = btoa(
                    JSON.stringify({
                        activeColor,
                        activeOptions,
                    })
                )
            }
        } catch (e) {
            console.error(e)
        }

        product_path =
            ($location.path && $location.path != "/" ? $location.path + "/" : "") +
            product.code +
            "_" +
            langField(product.slug, "") +
            "#" +
            hash
    }
</script>

<div class="product_teaser" style="cursor: pointer">
    <!-- <h3>Vorgeschlagenes Produkt</h3> -->
    <div class="product">
        <div class="images">
            <ProductImage
                {product}
                {activeImage}
                alt="{langField(product.name, '')}"
                {activeColor}
                {activeOptions}
                bind:imageColorMismatch
            />
            <ProductThumbnails {product} bind:activeImage bind:activeColor />
        </div>

        <div class="text">
            <div
                class="title"
                on:click="{() => {
                    navigate(product_path)
                }}"
            >
                {langField(product.name, "")}
            </div>
            <div class="artnr">
                {$_("product-config.item-number-short")}
                {product.code}
            </div>

            <a
                href="{product_path}"
                on:click|preventDefault="{() => {
                    // href in a will discard hash
                    navigate(product_path)
                }}"
                class="details_button">» {$_("product-config.more-details")}</a
            >

            <ProductOptions {product} bind:activeColor bind:activeOptions {imageColorMismatch} />

            <div class="price">
                {$formatPriceCurrency(
                    getProductPrice(product, activeColor, activeOptions, !!$login),
                    $login ? 0 : $checkoutData.vat
                )}
            </div>
            <div class="mwst">
                {$_("product-config.retail-price")}
                {#if $login}
                    {$_("product-config.excl-vat")}
                {:else}
                    {$_("product-config.incl-vat")}
                {/if}
            </div>
            {#if product.inquiry}
                <button
                    on:click="{() => {
                        $contentOverlay = {
                            component: ProductInquiry,
                            props: { product, activeColor, activeOptions },
                        }
                    }}"
                    class="btn btn-secondary"
                >
                    {$_("product-config.make-inquiry")}
                </button>
            {/if}
        </div>
    </div>
</div>

<style lang="less">
    @import "../../../css/variables.less";
    .product_teaser {
        width: 65%;
        padding-left: 30px;
        border-left: 1px solid var(--border-color-default);
        .flex();
        flex-direction: column;
        align-items: center;
        justify-content: stretch;
        @media (max-width: 1450px) {
            width: 50%;
        }
        @media (max-width: 1000px) {
            width: 50%;
            border-left: 0;
        }
        @media (max-width: 768px) {
            padding-left: 0px;
            padding: 0px 20px;
            width: 100%;
        }
        .product {
            height: 100%;
            .flex();
            align-items: stretch;
            @media (max-width: 1440px) {
                flex-direction: column;
            }
            @media (max-width: 768px) {
                flex-direction: row;
            }
            @media (max-width: 650px) {
                flex-direction: column;
            }
            .images {
                .flex();
                width: 65%;
                height: 100%;
                margin-right: 30px;
                @media (max-width: 1650px) {
                    display: block;
                }
                @media (max-width: 1450px) {
                    width: 100%;
                    height: auto;
                    margin-bottom: 20px;
                }
                @media (max-width: 1200px) {
                    flex-direction: column;
                }
                @media (max-width: 768px) {
                    height: auto;
                }
                @media (max-width: 650px) {
                    width: 100%;
                    height: auto;
                    margin-bottom: 20px;
                }
                :global {
                    .list {
                        order: 1;
                        height: 100%;
                        width: 100px;
                        @media (max-width: 1650px) {
                            width: 100%;
                            height: 100px;
                            .flex();
                            order: 2;
                        }
                        .image {
                            margin-right: 10px;

                            @media (max-width: 768px) {
                                width: 70px;
                                height: 70px;
                            }
                        }
                    }
                }
            }

            .text {
                font-size: 1.2rem;
                width: 35%;
                @media (max-width: 1450px) {
                    width: 80%;
                }
                .title {
                    font-size: 1.2rem;
                    line-height: 1.2;
                    font-weight: 600;
                }
                .price {
                    color: var(--primary);
                    font-size: 1.4rem;
                    margin-top: 20px;
                }
                .mwst {
                    font-size: 0.7rem;
                    margin-top: -7px;
                    margin-bottom: 15px;
                }
                .artnr {
                    font-size: 0.7rem;
                }
                .btn {
                    margin-top: 10px;
                }
            }
        }
    }
    .details_button {
        color: var(--tertiary);
        font-size: 1rem;
        margin-bottom: 20px;
        display: block;
    }
</style>
